import { PrivateAPINamespace } from '../PrivateAPINamespace';
import { createRefComponentsError, RefComponentsErrorCode, } from './RefComponentsError';
import { 
// IsReferredComponent,
findComponentBySelector, isRefComponent, getFirstRefComponent, } from './helpers';
export class RefComponentsNamespace extends PrivateAPINamespace {
    findComponentBySelector(compRef, selector) {
        const component = findComponentBySelector(this.ps.ds, compRef, selector);
        if (!component) {
            throw createRefComponentsError(RefComponentsErrorCode.UnableToFindComponentBySelector, 'Unable to find component by selector ').withSelector(selector);
        }
        return component.componentRef;
    }
    // @IsReferredComponent
    async hideReferredComponent(applicationId, compRef) {
        this.ps.ds.runInContext(applicationId, () => {
            return this.ps.ds.components.remove(compRef);
        });
        await this.waitForChangesApplied();
    }
    // @IsReferredComponent
    async showReferredComponent(applicationId, compRef) {
        this.ps.ds.runInContext(applicationId, () => {
            return this.ps.ds.components.refComponents.unGhostifyComponent(compRef);
        });
        await this.waitForChangesApplied();
    }
    async hideBySelector(applicationId, rootComp, selector) {
        const componentToHide = findComponentBySelector(this.ps.ds, rootComp, selector);
        if (!componentToHide) {
            throw createRefComponentsError(RefComponentsErrorCode.UnableToFindComponentBySelector, 'Unable to find component by selector').withSelector(selector);
        }
        await this.hideReferredComponent(applicationId, componentToHide.componentRef);
    }
    async showBySelector(applicationId, rootComp, selector) {
        const componentToShow = findComponentBySelector(this.ps.ds, rootComp, selector);
        if (!componentToShow) {
            throw createRefComponentsError(RefComponentsErrorCode.UnableToFindComponentBySelector, 'Unable to find component by selector').withSelector(selector);
        }
        await this.showReferredComponent(applicationId, componentToShow.componentRef);
    }
    async getHiddenComponents(refComponentRef, options) {
        if (!isRefComponent(this.ps.ds, refComponentRef)) {
            throw createRefComponentsError(RefComponentsErrorCode.UnableToGetHiddenNoneRefComponents, 'Unable to get hidden none ref components for the given component').withComponentId(refComponentRef.id);
        }
        const refComponents = [refComponentRef];
        if (options?.includeNested) {
            const children = this.ps.ds.deprecatedOldBadPerformanceApis.components.getChildren(refComponentRef, true);
            children.forEach((compRef) => {
                if (isRefComponent(this.ps.ds, compRef)) {
                    refComponents.push(compRef);
                }
            });
        }
        return refComponents.reduce((acc, compRef) => {
            const ghostsComponents = this.ps.ds.components.refComponents.getAllGhostRefComponentsPrimaryConnection(compRef);
            if (ghostsComponents) {
                Object.keys(ghostsComponents).forEach((ghostId) => {
                    acc.push({
                        componentRef: this.ps.ds.components.get.byId(ghostId),
                        role: ghostsComponents[ghostId]?.role,
                    });
                });
            }
            return acc;
        }, []);
    }
    async getHiddenComponentRoles(rootComp, options) {
        const refComponent = getFirstRefComponent(this.ps.ds, rootComp);
        const hiddenComponents = await this.getHiddenComponents(refComponent, options);
        return hiddenComponents.map((hiddenComponent) => hiddenComponent.role);
    }
    async findHiddenComponentByRole(rootComp, role, options) {
        const refComponent = getFirstRefComponent(this.ps.ds, rootComp);
        const hiddenComponents = await this.getHiddenComponents(refComponent, options);
        const hiddenComponent = hiddenComponents.find((component) => component.role === role);
        return hiddenComponent?.componentRef || null;
    }
    async isHiddenBySelector(rootComp, selector) {
        const bySelectorComponent = findComponentBySelector(this.ps.ds, rootComp, selector);
        if (!bySelectorComponent) {
            return false;
        }
        const allHiddenComponents = await this.getHiddenComponentRoles(rootComp, {
            includeNested: true,
        });
        return allHiddenComponents.some((hiddenComponent) => hiddenComponent === bySelectorComponent.role);
    }
}
RefComponentsNamespace.namespace = 'refComponents';
//# sourceMappingURL=RefComponentsNamespace.js.map